import Alpine from 'alpinejs';
import Swiper, { Navigation, Scrollbar } from 'swiper';

Swiper.use([Navigation, Scrollbar]);

Alpine.data('timeline', () => ({
  start: -500,
  startLabel: '-500 BC',
  end: 2000,
  currentIndex: false,
  currentDate: 0,
  endLabel: '2000 AD',
  milestones: [
    {
      date: 1,
      label: '1 AD',
    },
    {
      date: 1000,
      label: '1000 AD',
    },
  ],
  popup: false,
  popupContent: {},
  dates: [
    {
      date: 323,
      label: '323 BC',
      title: '323 BC',
      description: 'Seleucid domination of present-day Syria',
      addtionals: '',
      model: false,
    },
    {
      date: 140,
      label: '140 BCE',
      title: '140 BCE',
      description:
        'Construction and occupation of the tombs located behind the temple of Baalshamîn (dating given by the material, lamp and by inscriptions).',
      addtionals:
        'Terminus post quem thanks to a coin from Arados (inv. Br. 219). dated back to 140/139 BCE.',
      model: true,
    },
    {
      date: 11,
      label: '11 BCE',
      title: '11 BCE',
      description: 'Construction of tomb G (dated by an inscription)',
      addtionals: 'Inscriptions no 60, 61: 11 AD',
      model: true,
    },
    {
      date: 19,
      label: '19 AD',
      title: '19 AD',
      description: 'Roman domination by Roman emperor Tibere',
      addtionals: '',
      model: false,
    },
    {
      date: 20,
      label: '20 CE',
      title: '20 CE',
      description: 'Erection of the temenos',
      addtionals: '',
      model: true,
    },
    {
      date: 67,
      label: '67 CE',
      title: '67 CE',
      description:
        'Erection of the porticoes (C1) and of the large courtyard (dating attested by several inscriptions on architraves and portico columns). And erection of the banquet room.',
      addtionals: '',
      model: true,
    },
    {
      date: 90,
      label: '90 CE',
      title: '90 CE',
      description: 'Construction of the columns around the future temple.',
      addtionals: '',
      model: true,
    },
    {
      date: 103,
      label: '103 CE',
      title: '103 CE',
      description: 'Construction of the T1 portico that seals the graves',
      addtionals: 'Inscription no9 (inv. fouille 36) : probably around 103 CE.',
      model: true,
    },
    {
      date: 115,
      label: '115 CE',
      title: '115 CE',
      description: 'February 7, placement of a limestone altar with a bilingual inscription in Greek and Palmyrene. The altar is dedicated to Zeus (Baalshamîn).',
      addtionals: '',
      model: true,
    },
    {
      date: 130,
      label: '130 CE',
      title: '130 CE',
      description:
        'Erection of the temple of Baalshamîn (dating attested by an inscription)',
      addtionals: 'Inscription no44 : 130-131 AD.',
      model: true,
    },
    {
      date: 149,
      label: '149 CE',
      title: '149 CE',
      description:
        'Erection of the porticoes of the peristyle of the southern court (dated according to an inscription). Erection of columns of “bâtiment nord”.',
      addtionals: 'Inscription no19 : 149 AD.',
      model: true,
    },
    {
      date: 211,
      label: '211 AD',
      title: '211 AD',
      description: 'Colony status (granted by Caracalla)',
      addtionals: '',
      model: false,
    },
    {
      date: 272,
      label: '272 AD',
      title: '272 AD',
      description:
        'Capture of Queen Zenobia. In 273 the town is sized by Roman emperor Aurelian',
      addtionals: '',
      model: false,
    },
    {
      date: 325,
      label: '325 AD',
      title: '325 AD',
      description:
        'A bishop of Palmyra is mentioned in the list of the council of Nicaea',
      addtionals: '',
      model: false,
    },
    {
      date: 370,
      label: '370 CE',
      title: '370 CE',
      description:
        'Construction of buildings A and C in the large courtyard of the sanctuary. ',
      addtionals:
        'According to Intagliata 2016, p. 193, the buildings would have been constructed before the 6th c.',
      model: true,
    },
    {
      date: 450,
      label: '450 CE',
      title: '450 CE',
      description:
        'Byzantine alterations to the temple of Baalshamîn, destruction of the thalamos and creation of Byzantine apses',
      addtionals: '',
      model: true,
    },
    {
      date: 634,
      label: '634-XIIIe s. AD',
      title: '634-XIIIe s. AD',
      description: 'Arab occupation of the site of Palmyra',
      addtionals: '',
      model: false,
    },
    {
      date: 750,
      label: '750 CE',
      title: '750 CE',
      description: 'Erection of building B (or Arab quarter)',
      addtionals: '',
      model: true,
    },
    {
      date: 1929,
      label: '1929 AD',
      title: '1929 AD',
      description:
        'Creation of the current village and evacuation of the houses located inside the enclosure of the sanctuary of Bêl',
      addtionals: '',
      model: false,
    },
    {
      date: 1954,
      label: '1st september-27 october 1954',
      title: '1st september-27 october 1954',
      description:
        'Swiss archaeological mission led by Paul Collart on the sanctuary of Baalshamîn',
      addtionals: '',
      model: false,
    },
    {
      date: 1954,
      label: '1954 CE',
      title: '1954 CE',
      description:
        'Anastylosis of the portico of the southern courtyard of the sanctuary of Baalshamîn',
      addtionals: '',
      model: true,
    },
    {
      date: 1955,
      label: '1st september-25 october 1955',
      title: '1st september-25 october 1955',
      description:
        'Swiss archaeological mission led by Paul Collart on the sanctuary of Baalshamîn',
      addtionals: '',
      model: false,
    },
    {
      date: 1969,
      label: '1969 CE',
      title: '1969 CE',
      description: 'Anastylosis of the thalamos',
      addtionals: '',
      model: true,
    },
    {
      date: 2015,
      label: '2015',
      title: '2015',
      description: 'Destruction of Baalshamin temple and other monuments',
      addtionals: '',
      model: true,
    },
  ],
  moveDate(date) {
    this.currentDate = this.position(date);
  },
  position(date) {
    return ((date - this.start) / (this.end - this.start)) * 100;
  },
  init() {
    this.dates.forEach((e) => {
      e.active = false;
    });
  },
  swiper() {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.swiper', {
      slidesPerView: 'auto',
      resistanceRatio: 0,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        click: (e) => {
          swiper.slideTo(e.clickedIndex, 10, false);
        }
      },
    });

    // Set initial slide
    swiper.slideTo(9);
    this.toggle(9);
  },
  removeActive() {
    if (this.currentIndex !== false) {
      this.dates[this.currentIndex].active = false;
    }
  },
  toggle(i) {
    this.removeActive();
    this.currentIndex = i;
    this.showPopup();
    this.dates[i].active = true;
    this.moveDate(this.dates[i].date);
    this.popupContent = this.dates[i];
    if (this.dates[i].model) {
      // eslint-disable-next-line no-undef
      sliderInput(this.dates[i].date);
    }
  },
  showPopup() {
    this.popup = true;
  },
  closePopup() {
    this.removeActive();
    this.popup = false;
    this.popupContent = {};
  },
}));

window.Alpine = Alpine;

Alpine.start();
